var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"ims nrk",attrs:{"src":"img/js-3.jpg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }